export default __webpack_public_path__ + "media/zurb/img/about/bryan/bryan-img1-521f000dea6bb3808516c50a044c6581.png";